module.exports = __webpack_public_path__ + "static/media/laundry_icon.1e6f5300.svg";